export default __webpack_public_path__ + "static/media/bsc_logo.b4b377fe.svg";